export default __webpack_public_path__ + "static/media/settings.1b1b0b71.svg";